import axios from 'axios';

const create = (data) => axios.post('/cancelamentos', data);
const get = (id) => axios.get(`/cancelamentos/${id}`);
const list = (params) => axios.get('/cancelamentos', { params });
const update = (id, aluno) => axios.put(`/cancelamentos/${id}`, aluno);
const remove = (id) => axios.delete(`/cancelamentos/${id}`, {});
const save = (cancelamento) => {
  if (cancelamento.id) {
    return update(cancelamento.id, cancelamento);
  }
  return create(cancelamento);
};

export default {
  create,
  get,
  list,
  update,
  save,
  remove,
};
